export function removeHtmlStyle(html) {
  let relTag = /<.+?>/g; //去除标签
  let newHtml = "";
  if (html) {
    newHtml = html.replace(relTag, "");
  }
  return newHtml;
}
